// Characters excluding I/O/1/0 to avoid confusion
const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const CODE_LENGTH = 8;

export function generateRoomCode() {
  // The room code is the de-facto access capability (anyone with the code can
  // join), so use cryptographically secure randomness rather than Math.random().
  // Reject-sample to avoid modulo bias across the 32-char alphabet.
  let code = '';
  const max = 256 - (256 % CHARS.length); // largest unbiased byte threshold
  while (code.length < CODE_LENGTH) {
    const bytes = new Uint8Array(CODE_LENGTH);
    crypto.getRandomValues(bytes);
    for (let i = 0; i < bytes.length && code.length < CODE_LENGTH; i++) {
      if (bytes[i] < max) code += CHARS[bytes[i] % CHARS.length];
    }
  }
  return code;
}

export function validateRoomCode(code) {
  // Accept both legacy 6-char codes and new 8-char codes
  return typeof code === 'string' && /^[A-Z0-9]{6,8}$/.test(code);
}

export function formatRoomCode(input) {
  return (input || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, CODE_LENGTH);
}
